'use client'

import Image from 'next/image'
import { useRouter } from 'next/navigation'
import Button from '@/components/controls/Button'

export default function NotFound() {
  const router = useRouter()
  return (
    <div className="flex flex-col items-center justify-center p-6 min-h-screen bg-login-gradient">
      <div className="text-center mb-8">
        <div className="inline-block p-4 w-full max-w-md">
          <Image
            src="/logo_dark.png"
            alt="Alyrica Logo"
            width={640}
            height={110}
            style={{ height: 'auto', width: '100%' }}
          />
        </div>
        <h3 className="text-xl font-bold text-white mt-4">The page you're looking for could not be found.</h3>
      </div>
      <Button
        variant='primary'
        size='lg'
        onClick={() => router.push('/')}
      >
        Go Home
      </Button>
      <div className="mt-8 text-center text-white">
        <p className="text-md">Need help? Call us at <a href="tel:5419293330">(541) 929-3330</a></p>
      </div>
    </div>
  )
}
